// extracted by mini-css-extract-plugin
export default {"callButton":"CallButton_callButton__-T53+","icon":"CallButton_icon__YuSRg"};